import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { ValidationModal } from '@/components/ui/ValidationModal'
import type { UseCompanyInfoTabReturn } from '@/features/company/types'
import { companyEditConfirmPresentation } from '@/features/company/constants'

export function CompanyInfoDialogs({
    showValidationModal,
    setShowValidationModal,
    validationModalMessage,
    validationModalTitle,
    showDisableConfirm,
    setShowDisableConfirm,
    cancelDisableConfirm,
    deleteW9Confirm,
    executeDeleteW9File,
    cancelDeleteW9File,
}: UseCompanyInfoTabReturn) {
    const closeValidationModal = () => setShowValidationModal(false)

    return (
        <>
            <ValidationModal
                isOpen={showValidationModal}
                title={validationModalTitle}
                message={validationModalMessage}
                variant={validationModalTitle.toLowerCase().includes('success') ? 'success' : 'error'}
                onClose={closeValidationModal}
                alignMessage
                okButtonStyle="saveChanges"
                showValidationIcon={
                    validationModalTitle === 'Validate Address' ||
                    validationModalTitle === 'Validation Message'
                }
                overlayDataTestId="company-info-address-validation-modal-overlay"
                closeButtonDataTestId="company-info-address-validation-modal-close-button"
                confirmButtonDataTestId="company-info-address-validation-modal-ok-button"
            />
            <ConfirmDialog
                isOpen={showDisableConfirm}
                title="Confirm Company Disable?"
                message={
                    "Removing this listing will prevent potential residents from creating an application for this Company's Properties. Also, disabling a Company will de-activate all Properties associated with this Company.\n\nPlease confirm that you want to proceed."
                }
                messageLayout="listingConfirm"
                {...companyEditConfirmPresentation}
                primaryLabel="Confirm"
                onPrimary={() => setShowDisableConfirm(false)}
                secondaryLabel="Cancel"
                onSecondary={cancelDisableConfirm}
                onDismiss={cancelDisableConfirm}
                overlayDataTestId="company-info-disable-confirm-overlay"
                primaryButtonDataTestId="company-info-disable-confirm-confirm-button"
                secondaryButtonDataTestId="company-info-disable-confirm-cancel-button"
                closeButtonDataTestId="company-info-disable-confirm-close-button"
            />
            <ConfirmDialog
                isOpen={deleteW9Confirm.isOpen}
                title="Remove Document"
                message="Please confirm that you really want to remove the file."
                {...companyEditConfirmPresentation}
                primaryLabel="Delete"
                onPrimary={() => void executeDeleteW9File()}
                secondaryLabel="Cancel"
                onSecondary={cancelDeleteW9File}
                onDismiss={cancelDeleteW9File}
                overlayDataTestId="company-info-w9-delete-confirm-overlay"
                primaryButtonDataTestId="company-info-w9-delete-confirm-delete-button"
                secondaryButtonDataTestId="company-info-w9-delete-confirm-cancel-button"
                closeButtonDataTestId="company-info-w9-delete-confirm-close-button"
            />
        </>
    )
}
